export const SocialLinks = {
  facebook: "https://www.facebook.com/VEETEE.Technologies",
  linkedin: "https://www.linkedin.com/company/veetee-technologies/",
  Captcha_Key1: "6LehgO8jAAAAAAWUJHGOaG5Te51RHzgLReBfjjZV",
};
